import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingVerificationComponent } from './pending-verification.component';
import { TranslateModule } from '@xref/ngx';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [PendingVerificationComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
  ],
  exports: [PendingVerificationComponent]
})
export class PendingVerificationModule {}
